// MIT © 2017 azu
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LogGroup = function () {
    /**
     * @type {string} title
     * @type {string} [useCaseName]
     */
    function LogGroup(_ref) {
        var title = _ref.title,
            useCaseName = _ref.useCaseName;

        _classCallCheck(this, LogGroup);

        this.title = title;
        this.useCaseName = useCaseName;
        /**
         * @type  {LogChunk|LogGroup[]}
         * @private
         */
        this._buffer = [];
    }

    /**
     * @returns {LogChunk|LogGroup[]}
     */


    LogGroup.prototype.addChunk = function addChunk(chunk) {
        this._buffer.push(chunk);
    };

    LogGroup.prototype.addGroup = function addGroup(group) {
        this._buffer.push(group);
    };

    _createClass(LogGroup, [{
        key: "children",
        get: function get() {
            return this._buffer;
        }
    }]);

    return LogGroup;
}();

exports.default = LogGroup;
module.exports = exports["default"];
//# sourceMappingURL=LogGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./~/almin-logger/lib/log/LogGroup.js
// module id = 139
// module chunks = 0